module.exports = __webpack_public_path__ + "static/img/empty.c9f6af74.png";